export const base = {
  martel: "Martel Sans, sans-serif",
  poppins: "Poppins, sans-serif",
  prospectus: "Prospectus, serif",
}

export type Base = Record<keyof typeof base, string>
